module.exports = __webpack_public_path__ + "media/packs/images/flags/BR-5e256efb9edc7cca7c819932095e6fe4.svg";